import React from "react";
import { Box, TextField } from "@mui/material";
import styles from "./DateRange.module.css";
import { DatePicker } from "@mui/x-date-pickers";
import { useConfig } from "../../../../context/ConfigContext";

export interface DateFieldProps {}

const GenericDateRange: React.FunctionComponent<DateFieldProps> = ({}) => {
  const { startDate, setStartDate, endDate, setEndDate } = useConfig();

  return (
    <Box className={styles.dateRangeContainer}>
      <Box className={styles.dateItem}>
        <DatePicker
          disableFuture
          renderInput={(params) => <TextField {...params} />}
          value={startDate}
          inputFormat="yyyy-MM-dd"
          onChange={(newValue) => {
            setStartDate(newValue);
          }}
        />
      </Box>
      <div className={styles.line}>—</div>
      <Box className={styles.dateItem}>
        <DatePicker
          disableFuture
          renderInput={(params) => <TextField {...params} />}
          value={endDate}
          inputFormat="yyyy-MM-dd"
          onChange={(newValue) => {
            setEndDate(newValue);
          }}
        />
      </Box>
    </Box>
  );
};

export default GenericDateRange;
